/** Сегментированный переключатель (.seg прототипа). */
export function Seg<K extends string>({
  options,
  value,
  onChange,
  label,
}: {
  options: [K, string][];
  value: K;
  onChange: (v: K) => void;
  label: string;
}) {
  return (
    <div className="seg" role="group" aria-label={label}>
      {options.map(([k, l]) => (
        <button key={k} type="button" aria-pressed={value === k} onClick={() => onChange(k)}>
          {l}
        </button>
      ))}
    </div>
  );
}

export function FieldLabel({ children }: { children: string }) {
  return (
    <div className="muted small" style={{ marginBottom: 6, fontWeight: 500 }}>
      {children}
    </div>
  );
}
